import { useState, useEffect, useContext } from 'react'
import styles from './styles.module.css'
import Table from '../../../components/Table'
import { StaffRosterContext } from '../../../utils/context'
import { useSelector } from 'react-redux'

export default function UmbInfo() {
  const { allForms } = useContext(StaffRosterContext)
  const { values, setFieldValue } = allForms

  // Данные из API (Redux)
  const { personTabData } = useSelector(state => state.personnel)
  const { umbInfo: apiUmbInfo } = personTabData || {}

  const [selectedResponsible, setSelectedResponsible] = useState(null)
  const [selectedCabinet, setSelectedCabinet] = useState(null)

  // Данные из Formik (composite type: array или { personal_equipment, room_equipment })
  const umbInfoData = values.umbInfo || []

  // Поддержка обоих форматов данных
  const responsibleRows = Array.isArray(umbInfoData)
    ? umbInfoData
    : (umbInfoData.personal_equipment || [])
  const cabinetRows = Array.isArray(umbInfoData)
    ? []
    : (umbInfoData.room_equipment || [])

  // Синхронизация API данных с Formik (только при первой загрузке)
  useEffect(() => {
    if (apiUmbInfo) {
      const hasData = Array.isArray(umbInfoData)
        ? umbInfoData.length > 0
        : (umbInfoData.personal_equipment?.length > 0 || umbInfoData.room_equipment?.length > 0)
      if (!hasData) {
        setFieldValue('umbInfo', apiUmbInfo)
      }
    }
  }, [apiUmbInfo, umbInfoData, setFieldValue])

  return (
    <div className={styles.tabWrapper}>
      {/* Первая таблица */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.tableTitle}>ТМЦ, у которых в качестве ответственного указан редактируемый сотрудник</h3>
      </div>
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Инв. номер</th>
              <th>Название</th>
            </tr>
          </thead>
          <tbody>
            {responsibleRows.length > 0 ? (
              responsibleRows.map(row => {
                const rowId = row.id || row.xp_key
                return (
                  <tr
                    key={rowId}
                    onClick={() => setSelectedResponsible(selectedResponsible === rowId ? null : rowId)}
                    className={selectedResponsible === rowId ? styles.selectedRow : ''}
                  >
                    <td>{row.inventory_number || row.inventoryNumber}</td>
                    <td>{row.name}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan="2" className={styles.emptyTable}>
                  Нет данных о ТМЦ
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Вторая таблица */}
      <div className={styles.qualificationForm}>
        <h3 className={styles.tableTitle}>ТМЦ у которых указан кабинет, в качестве ответственного у которого указан редактируемый сотрудник</h3>
      </div>
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Инв. номер</th>
              <th>Название</th>
              <th>Кабинет</th>
            </tr>
          </thead>
          <tbody>
            {cabinetRows.length > 0 ? (
              cabinetRows.map(row => {
                const rowId = row.id || row.xp_key
                return (
                  <tr
                    key={rowId}
                    onClick={() => setSelectedCabinet(selectedCabinet === rowId ? null : rowId)}
                    className={selectedCabinet === rowId ? styles.selectedRow : ''}
                  >
                    <td>{row.inventory_number || row.inventoryNumber}</td>
                    <td>{row.name}</td>
                    <td>{row.cabinet || row.room}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan="3" className={styles.emptyTable}>
                  Нет данных о ТМЦ в кабинетах
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
